/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import StorageIcon from "@mui/icons-material/Storage";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
import {
    AppBar,
    Avatar,
    Drawer,
    styled,
    Toolbar,
    Tooltip,
    Typography,
    useTheme
} from "@mui/material";
import home from "../../assets/icons/home.png";
import user from "../../assets/icons/user.png";
import file from "../../assets/icons/file.png";
import db from "../../assets/icons/db.png";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";

import {
    accountManager,
    accountManagerHead,
    admin,
    NPDManager,
    NPDManagerHead,
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInName,
    getLoggedInProfilePic,
    getLoggedInUserDepartment,
    getLoggedInUserGroup,
    getLoggedInUserID,
    getLoggedInUserRole,
    isAdmin,
    Management,
    productionManager,
    productionManagerHead,
    qualityManager,
    qualityManagerHead,
    sourcingManager,
    sourcingManagerHead
} from "../../Utils/Constant";

const currentVersion = process.env.REACT_APP_VERSION;
interface SidebarProps {
    isOpen: boolean;
    activePage: string;
    setActivePage: (page: string) => void;
}
const CustomListItemIcon = styled(ListItemIcon)({
    color: "#90A4AE",
    minWidth: "40px"
});

const Sidebar: React.FC<SidebarProps> = ({
    isOpen,
    activePage,
    setActivePage
}) => {
    const [open] = React.useState(true);
    const [openCollapse, setOpenCollapse] = React.useState(
        localStorage.getItem("openCollapse") === "true"
    );
    const [openCollapse1, setOpenCollapse1] = React.useState(
        localStorage.getItem("openCollapse1") === "true"
    );
    const [openCollapseAC, setOpenCollapseAC] = React.useState(
        localStorage.getItem("openCollapseAC") === "true"
    );
    const [openCollapseCompany, setOpenCollapseCompany] = React.useState(
        localStorage.getItem("openCollapseCompany") === "true"
    );
    const [openCollapseQM, setOpenCollapseQM] = React.useState(
        localStorage.getItem("openCollapseQM") === "true"
    );
    const [openCollapsePM, setOpenCollapsePM] = React.useState(
        localStorage.getItem("openCollapsePM") === "true"
    );
    const [openCollapseDesign, setOpenCollapseDesign] = React.useState(
        localStorage.getItem("openCollapseDesign") === "true"
    );
    const [openCollapsePO, setOpenCollapsePO] = React.useState(
        localStorage.getItem("openCollapsePO") === "true"
    );
    const userEmail = localStorage.getItem("email");

    const closeAll = () => {
        setOpenCollapse(false);
        setOpenCollapse1(false);
        setOpenCollapseAC(false);
        setOpenCollapseCompany(false);
        setOpenCollapseQM(false);
        setOpenCollapsePM(false);
        setOpenCollapseDesign(false);
        setOpenCollapsePO(false);

        localStorage.setItem("openCollapse", "false");
        localStorage.setItem("openCollapse1", "false");
        localStorage.setItem("openCollapseAC", "false");
        localStorage.setItem("openCollapseCompany", "false");
        localStorage.setItem("openCollapseQM", "false");
        localStorage.setItem("openCollapsePM", "false");
        localStorage.setItem("openCollapseDesign", "false");
        localStorage.setItem("openCollapsePO", "false");
    };

    const handleClick = () => {
        const newState = !openCollapse;
        closeAll();
        setOpenCollapse(newState);
        localStorage.setItem("openCollapse", JSON.stringify(newState));
    };
    const handleClickAccount = () => {
        const newState = !openCollapseAC;
        closeAll();
        setOpenCollapseAC(newState);
        localStorage.setItem("openCollapseAC", JSON.stringify(newState));
    };

    const handleClickCompany = () => {
        const newState = !openCollapseCompany;
        closeAll();
        setOpenCollapseCompany(newState);
        localStorage.setItem("openCollapseCompany", JSON.stringify(newState));
    };
    const handleClick1 = () => {
        const newState = !openCollapse1;
        closeAll();
        setOpenCollapse1(newState);
        localStorage.setItem("openCollapse1", JSON.stringify(newState));
    };

    const handleClickQM = () => {
        const newState = !openCollapseQM;
        closeAll();
        setOpenCollapseQM(newState);
        localStorage.setItem("openCollapseQM", JSON.stringify(newState));
    };

    const handleClickPM = () => {
        const newState = !openCollapsePM;
        closeAll();
        setOpenCollapsePM(newState);
        localStorage.setItem("openCollapsePM", JSON.stringify(newState));
    };

    const handleClickDesign = () => {
        const newState = !openCollapseDesign;
        closeAll();
        setOpenCollapseDesign(newState);
        localStorage.setItem("openCollapseDesing", JSON.stringify(newState));
    };

    const handleClickPO = () => {
        const newState = !openCollapsePO;
        closeAll();
        setOpenCollapsePO(newState);
        localStorage.setItem("openCollapsePO", JSON.stringify(newState));
    };

    const navigate = useNavigate();

    const handleNavigation = (page: string) => {
        setActivePage(page);
        navigate(`/layout/${page}`);
    };

    const img = generatProfilePicUrl(
        getLoggedInUserID(),
        getLoggedInProfilePic(),
        "Profile_Picture"
    );
    console.log("loginuser", getLoggedInUserGroup());
    return (
        <Drawer
            className="sidebar-height"
            variant="persistent"
            open={isOpen}
            sx={{
                flexShrink: 0,
                width: isOpen ? 270 : 0,
                position: { xs: "absolute", sm: "static" },
                zIndex: { sm: "auto" },
                "& .MuiDrawer-paper": {
                    width: 275,
                    boxSizing: "border-box",
                    left: 0,
                    top: { xs: "55px", sm: "69px" },
                    zIndex: 1,
                    background: "#051B2E",
                    boxShadow: "0px 0px 8px hsl(0deg 0% 71.73% / 50%)",
                    color: "#a7acb5"
                }
            }}
        >
            <List
                sx={{ width: "100%", maxWidth: 360, paddingTop: "0" }}
                component="nav"
            >
                <div
                    style={{
                        borderBottom: "1px solid #a6abb4",
                        padding: "0 15px 15px",
                        marginBottom: "10px",

                        display: "flex",
                        alignItems: "center",
                        color: "#fff"
                    }}
                >
                    <div style={{ marginRight: "10px" }}>
                        <Avatar
                            src={img}
                            sx={{ width: "45px", height: "45px" }}
                        ></Avatar>
                    </div>
                    <div style={{ paddingTop: "13px", color: "#fff" }}>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                            {getLoggedInName() || "-"}
                        </Typography>
                        <Typography variant="body2">
                            <div>{getLoggedInUserDepartment() || "-"}</div>
                        </Typography>
                        <Tooltip title={getLoggedInEmail()}>
                            <Typography
                                variant="body2"
                                pb={1}
                                sx={{
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    width: "180px"
                                }}
                            >
                                {getLoggedInEmail()}
                            </Typography>
                        </Tooltip>
                        {/*<Typography variant="caption" sx={{ lineHeight: "1.22" }}>
              {Array.isArray(getLoggedInUserGroup()) &&
              getLoggedInUserGroup().length > 0 ? (
                getLoggedInUserGroup().map((group: string, index: number) => (
                  <div key={index}>{group}</div>
                ))
              ) : (
                <div>-</div>
              )}
            </Typography>*/}
                    </div>
                </div>
                <div className="scrollSection">
                    <ListItemButton
                        onClick={() => handleNavigation("Dashboard")}
                        selected={activePage === "Dashboard"}
                        style={{
                            backgroundColor:
                                activePage === "Dashboard"
                                    ? "#0288D14D"
                                    : "transparent",
                            color:
                                activePage === "Dashboard" ? "#fff" : "#90A4AE",
                            margin: activePage === "Dashboard" ? "0 10px" : "0",
                            padding:
                                activePage === "Dashboard"
                                    ? "4px 5px"
                                    : "revert-layer",
                            borderRadius:
                                activePage === "Dashboard" ? "5px" : "0"
                        }}
                    >
                        <CustomListItemIcon>
                            <img src={home} width={"18px"} />
                        </CustomListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItemButton>

                    {admin() && (
                        <>
                            <ListItemButton
                                onClick={() => handleNavigation("Rbac")}
                                selected={activePage === "Rbac"}
                                style={{
                                    backgroundColor:
                                        activePage === "Rbac"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "Rbac"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "Rbac" ? "0 10px" : "0",
                                    padding:
                                        activePage === "Rbac"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "Rbac" ? "5px" : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <GroupsOutlinedIcon />
                                </CustomListItemIcon>
                                <ListItemText primary="RBAC" />
                            </ListItemButton>
                            <ListItemButton
                                onClick={() => handleNavigation("RolesDep")}
                                selected={activePage === "RolesDep"}
                                style={{
                                    backgroundColor:
                                        activePage === "RolesDep"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "RolesDep"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "RolesDep"
                                            ? "0 10px"
                                            : "0",
                                    padding:
                                        activePage === "RolesDep"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "RolesDep" ? "5px" : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <ManageAccountsOutlinedIcon />
                                </CustomListItemIcon>
                                <ListItemText primary="Roles and Departments" />
                            </ListItemButton>
                        </>
                    )}

                    {/* Account Management */}
                    {(accountManager() ||
                        accountManagerHead() ||
                        Management()) && (
                        <>
                            <ListItemButton onClick={handleClickAccount}>
                                <CustomListItemIcon>
                                    <img src={user} width={"22px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Clients" />
                                {openCollapseAC ? (
                                    <ExpandLess sx={{ marginLeft: "10px" }} />
                                ) : (
                                    <ExpandMore sx={{ marginLeft: "10px" }} />
                                )}
                            </ListItemButton>
                            <Collapse
                                in={openCollapseAC}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() =>
                                            handleNavigation("OrgRepo")
                                        }
                                        selected={activePage === "OrgRepo"}
                                        style={{
                                            backgroundColor:
                                                activePage === "OrgRepo"
                                                    ? "#0288D14D"
                                                    : "transparent",
                                            color:
                                                activePage === "OrgRepo"
                                                    ? "#fff"
                                                    : "#90A4AE",
                                            margin:
                                                activePage === "OrgRepo"
                                                    ? "0 10px"
                                                    : "0",
                                            padding:
                                                activePage === "OrgRepo"
                                                    ? "4px 22px"
                                                    : "revert-layer",
                                            borderRadius:
                                                activePage === "OrgRepo"
                                                    ? "5px"
                                                    : "0"
                                        }}
                                    >
                                        <ListItemText
                                            primary="Organisations Repository"
                                            primaryTypographyProps={{
                                                fontSize: "0.875rem",
                                                paddingLeft: "1.5rem"
                                            }}
                                        />
                                    </ListItemButton>

                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() =>
                                            handleNavigation("Proposals")
                                        }
                                        selected={activePage === "Proposals"}
                                        style={{
                                            backgroundColor:
                                                activePage === "Proposals"
                                                    ? "#0288D14D"
                                                    : "transparent",
                                            color:
                                                activePage === "Proposals"
                                                    ? "#fff"
                                                    : "#90A4AE",
                                            margin:
                                                activePage === "Proposals"
                                                    ? "0 10px"
                                                    : "0",
                                            padding:
                                                activePage === "Proposals"
                                                    ? "4px 22px"
                                                    : "revert-layer",
                                            borderRadius:
                                                activePage === "Proposals"
                                                    ? "5px"
                                                    : "0"
                                        }}
                                    >
                                        <ListItemText
                                            primary="Proposals"
                                            primaryTypographyProps={{
                                                fontSize: "0.875rem",
                                                paddingLeft: "1.5rem"
                                            }}
                                        />
                                    </ListItemButton>
                                    {/* <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => handleNavigation("CompanyFeedback")}
                  selected={activePage === "CompanyFeedback"}
                  style={{
                    backgroundColor:
                      activePage === "CompanyFeedback"
                        ? "#0288D14D"
                        : "transparent",
                    color:
                      activePage === "CompanyFeedback" ? "#fff" : "#90A4AE",
                    margin: activePage === "CompanyFeedback" ? "0 10px" : "0",
                    padding:
                      activePage === "CompanyFeedback"
                        ? "4px 22px"
                        : "revert-layer",
                    borderRadius:
                      activePage === "CompanyFeedback" ? "5px" : "0",
                  }}
                >
                  <ListItemText
                    primary="Company Feedback"
                    primaryTypographyProps={{
                      fontSize: "0.875rem",
                      paddingLeft: "1.5rem",
                    }}
                  />
                </ListItemButton> */}
                                </List>
                            </Collapse>

                            {!Management() && (
                                <>
                                    <ListItemButton
                                        onClick={handleClickCompany}
                                    >
                                        <CustomListItemIcon>
                                            <img src={file} width={"18px"} />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Company RFQs" />
                                        {openCollapseCompany ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapseCompany}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CompanyRfq"
                                                    )
                                                }
                                                selected={
                                                    activePage === "CompanyRfq"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CompanyRfq"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CompanyRfq"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CompanyRfq"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CompanyRfq"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CompanyRfq"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="In Review"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>

                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation("FRfqList")
                                                }
                                                selected={
                                                    activePage === "FRfqList"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "FRfqList"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "FRfqList"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "FRfqList"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "FRfqList"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "FRfqList"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Feasible CORFQs "
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>

                                            {!(
                                                accountManager() ||
                                                accountManagerHead()
                                            ) && (
                                                <ListItemButton
                                                    sx={{ pl: 4 }}
                                                    onClick={() =>
                                                        handleNavigation(
                                                            "CURFQAssignedToMe"
                                                        )
                                                    }
                                                    selected={
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                                ? "#0288D14D"
                                                                : "transparent",
                                                        color:
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                                ? "#fff"
                                                                : "#90A4AE",
                                                        margin:
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                                ? "0 10px"
                                                                : "0",
                                                        padding:
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                                ? "4px 22px"
                                                                : "revert-layer",
                                                        borderRadius:
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                                ? "5px"
                                                                : "0"
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary="Assigned CORFQs"
                                                        primaryTypographyProps={{
                                                            fontSize:
                                                                "0.875rem",
                                                            paddingLeft:
                                                                "1.5rem"
                                                        }}
                                                    />
                                                </ListItemButton>
                                            )}

                                             <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation("DroppedRfq")
                                                }
                                                selected={
                                                    activePage === "DroppedRfq"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Dropped CORFQs "
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>

                                          
                                            {/**Purchase Order */}
                                        </List>
                                    </Collapse>
                                    <ListItemButton onClick={handleClickPO}>
                                        <CustomListItemIcon>
                                            <PrecisionManufacturingOutlinedIcon />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Production" />
                                        {openCollapsePO ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapsePO}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CoPoDatatable"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CoPoDatatable"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Company Purchase Order"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                </>
                            )}
                        </>
                    )}

                    {/* Sourcing Management */}
                    {(sourcingManager() ||
                        sourcingManagerHead() ||
                        Management()) && (
                        <>
                            <ListItemButton onClick={handleClick}>
                                <CustomListItemIcon>
                                    <img src={file} width={"18px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Company RFQs" />
                                {openCollapse ? (
                                    <ExpandLess sx={{ marginLeft: "10px" }} />
                                ) : (
                                    <ExpandMore sx={{ marginLeft: "10px" }} />
                                )}
                            </ListItemButton>
                            <Collapse
                                in={openCollapse}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <>
                                        <>
                                            {!sourcingManager() && (
                                                <>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        onClick={() =>
                                                            handleNavigation(
                                                                "CompanyRfq"
                                                            )
                                                        }
                                                        selected={
                                                            activePage ===
                                                            "CompanyRfq"
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                activePage ===
                                                                "CompanyRfq"
                                                                    ? "#0288D14D"
                                                                    : "transparent",
                                                            color:
                                                                activePage ===
                                                                "CompanyRfq"
                                                                    ? "#fff"
                                                                    : "#90A4AE",
                                                            margin:
                                                                activePage ===
                                                                "CompanyRfq"
                                                                    ? "0 10px"
                                                                    : "0",
                                                            padding:
                                                                activePage ===
                                                                "CompanyRfq"
                                                                    ? "4px 22px"
                                                                    : "revert-layer",
                                                            borderRadius:
                                                                activePage ===
                                                                "CompanyRfq"
                                                                    ? "5px"
                                                                    : "0"
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary="In Review"
                                                            primaryTypographyProps={{
                                                                fontSize:
                                                                    "0.875rem",
                                                                paddingLeft:
                                                                    "2.5rem"
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        onClick={() =>
                                                            handleNavigation(
                                                                "FRfqList"
                                                            )
                                                        }
                                                        selected={
                                                            activePage ===
                                                            "FRfqList"
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                activePage ===
                                                                "FRfqList"
                                                                    ? "#0288D14D"
                                                                    : "transparent",
                                                            color:
                                                                activePage ===
                                                                "FRfqList"
                                                                    ? "#fff"
                                                                    : "#90A4AE",
                                                            margin:
                                                                activePage ===
                                                                "FRfqList"
                                                                    ? "0 10px"
                                                                    : "0",
                                                            padding:
                                                                activePage ===
                                                                "FRfqList"
                                                                    ? "4px 22px"
                                                                    : "revert-layer",
                                                            borderRadius:
                                                                activePage ===
                                                                "FRfqList"
                                                                    ? "5px"
                                                                    : "0"
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary="Feasible CORFQs "
                                                            primaryTypographyProps={{
                                                                fontSize:
                                                                    "0.875rem",
                                                                paddingLeft:
                                                                    "2.5rem"
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                </>
                                            )}

                                            {(sourcingManager() ||
                                                sourcingManagerHead() ||
                                                Management()) && (
                                                <>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        onClick={() =>
                                                            handleNavigation(
                                                                "CURFQAssignedToMe"
                                                            )
                                                        }
                                                        selected={
                                                            activePage ===
                                                            "CURFQAssignedToMe"
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                activePage ===
                                                                "CURFQAssignedToMe"
                                                                    ? "#0288D14D"
                                                                    : "transparent",
                                                            color:
                                                                activePage ===
                                                                "CURFQAssignedToMe"
                                                                    ? "#fff"
                                                                    : "#90A4AE",
                                                            margin:
                                                                activePage ===
                                                                "CURFQAssignedToMe"
                                                                    ? "0 10px"
                                                                    : "0",
                                                            padding:
                                                                activePage ===
                                                                "CURFQAssignedToMe"
                                                                    ? "4px 22px"
                                                                    : "revert-layer",
                                                            borderRadius:
                                                                activePage ===
                                                                "CURFQAssignedToMe"
                                                                    ? "5px"
                                                                    : "0"
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary="Assigned CORFQs"
                                                            primaryTypographyProps={{
                                                                fontSize:
                                                                    "0.875rem",
                                                                paddingLeft:
                                                                    "2.5rem"
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        sx={{ pl: 4 }}
                                                        onClick={() =>
                                                            handleNavigation(
                                                                "DroppedRfq"
                                                            )
                                                        }
                                                        selected={
                                                            activePage ===
                                                            "DroppedRfq"
                                                        }
                                                        style={{
                                                            backgroundColor:
                                                                activePage ===
                                                                "DroppedRfq"
                                                                    ? "#0288D14D"
                                                                    : "transparent",
                                                            color:
                                                                activePage ===
                                                                "DroppedRfq"
                                                                    ? "#fff"
                                                                    : "#90A4AE",
                                                            margin:
                                                                activePage ===
                                                                "DroppedRfq"
                                                                    ? "0 10px"
                                                                    : "0",
                                                            padding:
                                                                activePage ===
                                                                "DroppedRfq"
                                                                    ? "4px 22px"
                                                                    : "revert-layer",
                                                            borderRadius:
                                                                activePage ===
                                                                "DroppedRfq"
                                                                    ? "5px"
                                                                    : "0"
                                                        }}
                                                    >
                                                        <ListItemText
                                                            primary="Dropped CORFQs"
                                                            primaryTypographyProps={{
                                                                fontSize:
                                                                    "0.875rem",
                                                                paddingLeft:
                                                                    "2.5rem"
                                                            }}
                                                        />
                                                    </ListItemButton>
                                                </>
                                            )}
                                        </>
                                    </>
                                </List>
                            </Collapse>
                            {(Management() || sourcingManagerHead()) && (
                                <>
                                    <ListItemButton onClick={handleClickPO}>
                                        <CustomListItemIcon>
                                            <PrecisionManufacturingOutlinedIcon />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Production" />
                                        {openCollapsePO ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapsePO}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CoPoDatatable"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CoPoDatatable"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Company Purchase Order"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                </>
                            )}
                            {/* {!sourcingManager() && ( */}
                            <ListItemButton
                                onClick={() =>
                                    handleNavigation("PartnerDatabase")
                                }
                                selected={activePage === "PartnerDatabase"}
                                style={{
                                    backgroundColor:
                                        activePage === "PartnerDatabase"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "PartnerDatabase"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "PartnerDatabase"
                                            ? "0 10px"
                                            : "0",
                                    padding:
                                        activePage === "PartnerDatabase"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "PartnerDatabase"
                                            ? "5px"
                                            : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <img src={db} width={"22px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Partner Database" />
                            </ListItemButton>
                            {/* )} */}
                        </>
                    )}

                    {/**Quality Management */}
                    {(qualityManager() || qualityManagerHead()) && (
                        <>
                            <ListItemButton onClick={handleClickQM}>
                                <CustomListItemIcon>
                                    <img src={file} width={"18px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Company RFQs" />
                                {openCollapseQM ? (
                                    <ExpandLess sx={{ marginLeft: "10px" }} />
                                ) : (
                                    <ExpandMore sx={{ marginLeft: "10px" }} />
                                )}
                            </ListItemButton>

                            <Collapse
                                in={openCollapseQM}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() =>
                                            handleNavigation("CompanyRfq")
                                        }
                                        selected={activePage === "CompanyRfq"}
                                        style={{
                                            backgroundColor:
                                                activePage === "CompanyRfq"
                                                    ? "#0288D14D"
                                                    : "transparent",
                                            color:
                                                activePage === "CompanyRfq"
                                                    ? "#fff"
                                                    : "#90A4AE",
                                            margin:
                                                activePage === "CompanyRfq"
                                                    ? "0 10px"
                                                    : "0",
                                            padding:
                                                activePage === "CompanyRfq"
                                                    ? "4px 22px"
                                                    : "revert-layer",
                                            borderRadius:
                                                activePage === "CompanyRfq"
                                                    ? "5px"
                                                    : "0"
                                        }}
                                    >
                                        <ListItemText
                                            primary="In Review"
                                            primaryTypographyProps={{
                                                fontSize: "0.875rem",
                                                paddingLeft: "1.5rem"
                                            }}
                                        />
                                    </ListItemButton>
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() =>
                                            handleNavigation("FRfqList")
                                        }
                                        selected={activePage === "FRfqList"}
                                        style={{
                                            backgroundColor:
                                                activePage === "FRfqList"
                                                    ? "#0288D14D"
                                                    : "transparent",
                                            color:
                                                activePage === "FRfqList"
                                                    ? "#fff"
                                                    : "#90A4AE",
                                            margin:
                                                activePage === "FRfqList"
                                                    ? "0 10px"
                                                    : "0",
                                            padding:
                                                activePage === "FRfqList"
                                                    ? "4px 22px"
                                                    : "revert-layer",
                                            borderRadius:
                                                activePage === "FRfqList"
                                                    ? "5px"
                                                    : "0"
                                        }}
                                    >
                                        <ListItemText
                                            primary="Feasible CORFQs "
                                            primaryTypographyProps={{
                                                fontSize: "0.875rem",
                                                paddingLeft: "1.5rem"
                                            }}
                                        />
                                    </ListItemButton>
                                    <ListItemButton
                                        sx={{ pl: 4 }}
                                        onClick={() =>
                                            handleNavigation("DroppedRfq")
                                        }
                                        selected={activePage === "DroppedRfq"}
                                        style={{
                                            backgroundColor:
                                                activePage === "DroppedRfq"
                                                    ? "#0288D14D"
                                                    : "transparent",
                                            color:
                                                activePage === "DroppedRfq"
                                                    ? "#fff"
                                                    : "#90A4AE",
                                            margin:
                                                activePage === "DroppedRfq"
                                                    ? "0 10px"
                                                    : "0",
                                            padding:
                                                activePage === "DroppedRfq"
                                                    ? "4px 22px"
                                                    : "revert-layer",
                                            borderRadius:
                                                activePage === "DroppedRfq"
                                                    ? "5px"
                                                    : "0"
                                        }}
                                    >
                                        <ListItemText
                                            primary="Dropped CORFQs "
                                            primaryTypographyProps={{
                                                fontSize: "0.875rem",
                                                paddingLeft: "1.5rem"
                                            }}
                                        />
                                    </ListItemButton>
                                </List>
                            </Collapse>

                            {qualityManagerHead() && (
                                <>
                                    <ListItemButton onClick={handleClickPO}>
                                        <CustomListItemIcon>
                                            <PrecisionManufacturingOutlinedIcon />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Production" />
                                        {openCollapsePO ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapsePO}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CoPoDatatable"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CoPoDatatable"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Company Purchase Order"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                </>
                            )}

                            <ListItemButton
                                onClick={() =>
                                    handleNavigation("PartnerDatabase")
                                }
                                selected={activePage === "PartnerDatabase"}
                                style={{
                                    backgroundColor:
                                        activePage === "PartnerDatabase"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "PartnerDatabase"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "PartnerDatabase"
                                            ? "0 10px"
                                            : "0",
                                    padding:
                                        activePage === "PartnerDatabase"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "PartnerDatabase"
                                            ? "5px"
                                            : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <img src={db} width={"22px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Partner Database" />
                            </ListItemButton>
                        </>
                    )}

                    {/**Production Management */}
                    {(productionManager() || productionManagerHead()) && (
                        <>
                            <ListItemButton onClick={handleClickPM}>
                                <CustomListItemIcon>
                                    <ApartmentIcon />
                                </CustomListItemIcon>
                                <ListItemText primary="Company RFQs" />
                                {openCollapse ? (
                                    <ExpandLess sx={{ marginLeft: "10px" }} />
                                ) : (
                                    <ExpandMore sx={{ marginLeft: "10px" }} />
                                )}
                            </ListItemButton>
                            <Collapse
                                in={openCollapsePM}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    {productionManagerHead() && (
                                        <ListItemButton
                                            sx={{ pl: 4 }}
                                            onClick={() =>
                                                handleNavigation("CompanyRfq")
                                            }
                                            selected={
                                                activePage === "CompanyRfq"
                                            }
                                            style={{
                                                backgroundColor:
                                                    activePage === "CompanyRfq"
                                                        ? "#0288D14D"
                                                        : "transparent",
                                                color:
                                                    activePage === "CompanyRfq"
                                                        ? "#fff"
                                                        : "#90A4AE",
                                                margin:
                                                    activePage === "CompanyRfq"
                                                        ? "0 10px"
                                                        : "0",
                                                padding:
                                                    activePage === "CompanyRfq"
                                                        ? "4px 22px"
                                                        : "revert-layer",
                                                borderRadius:
                                                    activePage === "CompanyRfq"
                                                        ? "5px"
                                                        : "0"
                                            }}
                                        >
                                            <ListItemText
                                                primary="In Review"
                                                primaryTypographyProps={{
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1.5rem"
                                                }}
                                            />
                                        </ListItemButton>
                                    )}
                                    {productionManagerHead() && (
                                        <ListItemButton
                                            sx={{ pl: 4 }}
                                            onClick={() =>
                                                handleNavigation("FRfqList")
                                            }
                                            selected={activePage === "FRfqList"}
                                            style={{
                                                backgroundColor:
                                                    activePage === "FRfqList"
                                                        ? "#0288D14D"
                                                        : "transparent",
                                                color:
                                                    activePage === "FRfqList"
                                                        ? "#fff"
                                                        : "#90A4AE",
                                                margin:
                                                    activePage === "FRfqList"
                                                        ? "0 10px"
                                                        : "0",
                                                padding:
                                                    activePage === "FRfqList"
                                                        ? "4px 22px"
                                                        : "revert-layer",
                                                borderRadius:
                                                    activePage === "FRfqList"
                                                        ? "5px"
                                                        : "0"
                                            }}
                                        >
                                            <ListItemText
                                                primary="Feasible CORFQs "
                                                primaryTypographyProps={{
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1.5rem"
                                                }}
                                            />
                                        </ListItemButton>
                                    )}
                                    {(productionManager() ||
                                        productionManagerHead()) && (
                                        <>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CURFQAssignedToMe"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CURFQAssignedToMe"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Assigned CORFQs"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "DroppedRfq"
                                                    )
                                                }
                                                selected={
                                                    activePage === "DroppedRfq"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Dropped CORFQs "
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </>
                                    )}
                                </List>
                            </Collapse>
                            {productionManagerHead() && (
                                <>
                                    <ListItemButton onClick={handleClickPO}>
                                        <CustomListItemIcon>
                                            <PrecisionManufacturingOutlinedIcon />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Production" />
                                        {openCollapsePO ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapsePO}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CoPoDatatable"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CoPoDatatable"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Company Purchase Order"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                </>
                            )}
                            <ListItemButton
                                onClick={() =>
                                    handleNavigation("PartnerDatabase")
                                }
                                selected={activePage === "PartnerDatabase"}
                                style={{
                                    backgroundColor:
                                        activePage === "PartnerDatabase"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "PartnerDatabase"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "PartnerDatabase"
                                            ? "0 10px"
                                            : "0",
                                    padding:
                                        activePage === "PartnerDatabase"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "PartnerDatabase"
                                            ? "5px"
                                            : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <img src={db} width={"22px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Partner Database" />
                            </ListItemButton>
                        </>
                    )}

                    {/**Finance Management */}
                    {(NPDManager() || NPDManagerHead()) && (
                        <>
                            <ListItemButton onClick={handleClickDesign}>
                                <CustomListItemIcon>
                                    <ApartmentIcon />
                                </CustomListItemIcon>
                                <ListItemText primary="Company RFQs" />
                                {openCollapseDesign ? (
                                    <ExpandLess sx={{ marginLeft: "10px" }} />
                                ) : (
                                    <ExpandMore sx={{ marginLeft: "10px" }} />
                                )}
                            </ListItemButton>
                            <Collapse
                                in={openCollapseDesign}
                                timeout="auto"
                                unmountOnExit
                            >
                                <List component="div" disablePadding>
                                    {NPDManagerHead() && (
                                        <ListItemButton
                                            sx={{ pl: 4 }}
                                            onClick={() =>
                                                handleNavigation("CompanyRfq")
                                            }
                                            selected={
                                                activePage === "CompanyRfq"
                                            }
                                            style={{
                                                backgroundColor:
                                                    activePage === "CompanyRfq"
                                                        ? "#0288D14D"
                                                        : "transparent",
                                                color:
                                                    activePage === "CompanyRfq"
                                                        ? "#fff"
                                                        : "#90A4AE",
                                                margin:
                                                    activePage === "CompanyRfq"
                                                        ? "0 10px"
                                                        : "0",
                                                padding:
                                                    activePage === "CompanyRfq"
                                                        ? "4px 22px"
                                                        : "revert-layer",
                                                borderRadius:
                                                    activePage === "CompanyRfq"
                                                        ? "5px"
                                                        : "0"
                                            }}
                                        >
                                            <ListItemText
                                                primary="In Review"
                                                primaryTypographyProps={{
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1.5rem"
                                                }}
                                            />
                                        </ListItemButton>
                                    )}
                                    {NPDManagerHead() && (
                                        <ListItemButton
                                            sx={{ pl: 4 }}
                                            onClick={() =>
                                                handleNavigation("FRfqList")
                                            }
                                            selected={activePage === "FRfqList"}
                                            style={{
                                                backgroundColor:
                                                    activePage === "FRfqList"
                                                        ? "#0288D14D"
                                                        : "transparent",
                                                color:
                                                    activePage === "FRfqList"
                                                        ? "#fff"
                                                        : "#90A4AE",
                                                margin:
                                                    activePage === "FRfqList"
                                                        ? "0 10px"
                                                        : "0",
                                                padding:
                                                    activePage === "FRfqList"
                                                        ? "4px 22px"
                                                        : "revert-layer",
                                                borderRadius:
                                                    activePage === "FRfqList"
                                                        ? "5px"
                                                        : "0"
                                            }}
                                        >
                                            <ListItemText
                                                primary="Feasible CORFQs "
                                                primaryTypographyProps={{
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1.5rem"
                                                }}
                                            />
                                        </ListItemButton>
                                    )}
                                    {(NPDManager() || NPDManagerHead()) && (
                                        <>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CURFQAssignedToMe"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CURFQAssignedToMe"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CURFQAssignedToMe"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Assigned CORFQs"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "DroppedRfq"
                                                    )
                                                }
                                                selected={
                                                    activePage === "DroppedRfq"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "DroppedRfq"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Dropped CORFQs "
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </>
                                    )}
                                </List>
                            </Collapse>
                            {NPDManagerHead() && (
                                <>
                                    <ListItemButton onClick={handleClickPO}>
                                        <CustomListItemIcon>
                                            <PrecisionManufacturingOutlinedIcon />
                                        </CustomListItemIcon>
                                        <ListItemText primary="Production" />
                                        {openCollapsePO ? (
                                            <ExpandLess
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        ) : (
                                            <ExpandMore
                                                sx={{ marginLeft: "10px" }}
                                            />
                                        )}
                                    </ListItemButton>
                                    <Collapse
                                        in={openCollapsePO}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List component="div" disablePadding>
                                            <ListItemButton
                                                sx={{ pl: 4 }}
                                                onClick={() =>
                                                    handleNavigation(
                                                        "CoPoDatatable"
                                                    )
                                                }
                                                selected={
                                                    activePage ===
                                                    "CoPoDatatable"
                                                }
                                                style={{
                                                    backgroundColor:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#0288D14D"
                                                            : "transparent",
                                                    color:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "#fff"
                                                            : "#90A4AE",
                                                    margin:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "0 10px"
                                                            : "0",
                                                    padding:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "4px 22px"
                                                            : "revert-layer",
                                                    borderRadius:
                                                        activePage ===
                                                        "CoPoDatatable"
                                                            ? "5px"
                                                            : "0"
                                                }}
                                            >
                                                <ListItemText
                                                    primary="Company Purchase Order"
                                                    primaryTypographyProps={{
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1.5rem"
                                                    }}
                                                />
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                </>
                            )}
                            <ListItemButton
                                onClick={() =>
                                    handleNavigation("PartnerDatabase")
                                }
                                selected={activePage === "PartnerDatabase"}
                                style={{
                                    backgroundColor:
                                        activePage === "PartnerDatabase"
                                            ? "#0288D14D"
                                            : "transparent",
                                    color:
                                        activePage === "PartnerDatabase"
                                            ? "#fff"
                                            : "#90A4AE",
                                    margin:
                                        activePage === "PartnerDatabase"
                                            ? "0 10px"
                                            : "0",
                                    padding:
                                        activePage === "PartnerDatabase"
                                            ? "4px 5px"
                                            : "revert-layer",
                                    borderRadius:
                                        activePage === "PartnerDatabase"
                                            ? "5px"
                                            : "0"
                                }}
                            >
                                <CustomListItemIcon>
                                    <img src={db} width={"22px"} />
                                </CustomListItemIcon>
                                <ListItemText primary="Partner Database" />
                            </ListItemButton>
                        </>
                    )}
                </div>
            </List>
            {/* <img
        src={Logo} // Ensure Logo is a valid path or import
        alt="Logo"
        style={{
          width: "35px",
          height: "auto",
          position: "absolute",
          bottom: "9%",
          left: "87%"
        }}
      /> */}
            <AppBar
                position="fixed"
                sx={{
                    top: "auto",
                    bottom: 0,
                    left: 0,
                    zIndex: 1100,
                    background: "#fff0",
                    width: "275px"
                }}
            >
                <Toolbar
                    sx={{
                        justifyContent: "center",
                        display: "grid",
                        textAlign: "center"
                    }}
                >
                    <Typography
                        color="#fff"
                        marginBottom={"-1.68rem"}
                        fontSize={"15px"}
                    >
                        ©2026 Machine Maze
                    </Typography>
                    <div>
                        <Typography variant="caption">
                            {currentVersion}
                        </Typography>
                    </div>
                </Toolbar>
            </AppBar>
        </Drawer>
    );
};

export default Sidebar;
